import { jicar } from "./jicar";
import { mesca } from "./mesca";
import { aipache } from "./aipache";
import { apache } from "./apache";
import type { AICharacter } from "../types";

export const aiCharacters: Record<string, AICharacter> = {
	jicar,
	mesca,
	aipache,
	apache,
};

export const getCharacter = (id: string): AICharacter | undefined => {
	return aiCharacters[id];
};
